import { render, staticRenderFns } from "./QLCWidget.vue?vue&type=template&id=66168adb&scoped=true"
import script from "./QLCWidget.vue?vue&type=script&lang=js"
export * from "./QLCWidget.vue?vue&type=script&lang=js"
import style0 from "./QLCWidget.vue?vue&type=style&index=0&id=66168adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66168adb",
  null
  
)

export default component.exports